module.exports = __webpack_public_path__ + "static/img/7bg_9.bc92628.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/7bg_9.png
// module id = 755
// module chunks = 1